import axiosBase from '~/utils/axios';

export default class AuthApi {
  public static async login(payload: any) {
    return axiosBase.post(`/login`, payload).then(({ data }) => data);
  }

  public static async changeLang(userId: string, language: string) {
    return axiosBase.post(`/account/${userId}/updateLanguage`, { language });
  }

  public static async AuthLogo() {
    return axiosBase.get(`/logo`);
  }

  public static async refreshToken() {
    return axiosBase.post(`/auth/refresh-token`);
  }

  public static async logout() {
    return axiosBase.post(`/auth/logout`);
  }
}
